<template>
    <div class="drag-mover" :class="{edit}" :style="styler">
        <slot />
        <div class="info" v-if="edit">
            x:{{x}} y:{{y}} w:{{w}} h:{{h}}
        </div>
        <div class="move-btn" @mousedown="startMove" v-if="edit">
            <div class="fa fa-arrows"></div>
        </div>
        <div class="bottom-angle" @mousedown="startResize" v-if="edit">
            <i-svg name="angle" :width="32" />
        </div>
    </div>
</template>
<script>
export default {
    name: "drag-mover",
    props: {
        pos: {
            type: Object,
            default () {
                return {}
            }
        },
        edit: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        styler() {
            let { x, y, h, w } = this;
            let stl = {};
            if(x&&y&&w&&h) stl.position = 'absolute';
            if (x) stl.left = x + 'px';
            if (y) stl.top = y + 'px';
            if (w) stl.width = w + 'px';
            if (h) stl.height = h + 'px';
            return stl;

        }
    },
    mounted() {
        this.x = this.pos.x;
        this.y = this.pos.y;
        this.w = this.pos.w;
        this.h = this.pos.h;
    },
    methods: {
        startMove(e) {
            let { clientX, clientY } = e;
            console.log('START', { clientX, clientY })
            this.startX = clientX;
            this.startY = clientY;
            this.initX = this.x;
            this.initY = this.y;
            document.body.addEventListener('mousemove', this.onMove);
            document.body.addEventListener('mouseup', this.onMoveStop);
        },
        onMoveStop() {
            let { x, y, w, h } = this;
            document.body.removeEventListener('mousemove', this.onMove);
            document.body.removeEventListener('mouseup', this.onMoveStop);
            this.$emit('input', { x, y, w, h });
        },
        onMove(e) {
            let { clientX, clientY } = e;
            let { startX, startY, initX, initY } = this;
            this.x = initX + clientX - startX;
            this.y = initY + clientY - startY;
            console.log('MOVE', { x: clientX - startX, y: clientY - startY })
        },

        startResize(e) {
            let { clientX, clientY } = e;
            console.log('START', { clientX, clientY })
            this.startX = clientX;
            this.startY = clientY;
            this.initX = this.w;
            this.initY = this.h;
            document.body.addEventListener('mousemove', this.onResize);
            document.body.addEventListener('mouseup', this.onResizeStop);
        },
        onResizeStop() {
            let { x, y, w, h } = this;
            document.body.removeEventListener('mousemove', this.onResize);
            document.body.removeEventListener('mouseup', this.onResizeStop);
            this.$emit('input', { x, y, w, h })
        },
        onResize(e) {
            let { clientX, clientY } = e;
            let { startX, startY, initX, initY } = this;
            this.w = initX + clientX - startX;
            this.h = initY + clientY - startY;
            console.log('MOVE', { x: clientX - startX, y: clientY - startY })

        },
    },
    data() {
        return {
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            startX: 0,
            startY: 0
        }
    }
}
</script>
<style scoped>
.drag-mover {
    display: block;

}

.drag-mover.edit {
    outline: 1px solid #eee;

}

.drag-mover.edit:hover {
    outline: 1px solid red;
}

.drag-mover.edit:hover .bottom-angle,
.drag-mover.edit:hover .info,
.drag-mover.edit:hover .move-btn {
    display: block;
}



.bottom-angle {
    position: absolute;
    bottom: 0px;
    right: 0px;
    cursor: se-resize;
    display: none;
}

.move-btn {
    position: absolute;
    top: 0;
    right: 0;
    cursor: move;
    display: none;
}

.info {
    position: absolute;
    left: 0;
    bottom: 0;
    display: none;
}
</style>